module.exports = __webpack_public_path__ + "img/placeholder.9eda9407.png";